<script>
import ModelShow from "../models/show";
// import Row from '@/components/models/show/custom-row';

export default {
  extends: ModelShow,
  page: {
    title: "Detail Tickets"
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("tickets.singular"));
      }
    },
    resourceRoute: { default: "tickets" },
    modelVariable: { default: "ticket" },
    denyEdit: { type: Boolean, default: true },
    denyDelete: { type: Boolean, default: true }
    // columns: {
    //   type: Object,
    //   default() {
    //     return {
    //       [this.modelVariable || 'model']: [
    //         {
    //           key: 'key',
    //           label: this.$t('models.key'),
    //           component: Row
    //         }
    //       ]
    //     };
    //   }
    // },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t("tickets.plural")),
      prevRoute: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  mounted() {
    window.onpopstate = function() {
      this.$router.push(this.prevRoute);
    }.bind(this);

    this.fetchModel();
  },
  beforeDestroy() {
    // reset onpopstate behavior
    window.onpopstate = null;
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t("tickets.plural")),
          href: "/tickets"
        },
        {
          text: this.model && this.model.id ? this.model.id : this.$route.params.key,
          href: `/tickets/${this.$route.params.key}`,
          active: true
        }
      ];
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model)
        ? []
        : [
            {
              key: this.lodash.startCase(this.$t(`${this.resourceRoute}.ticket_id`)),
              value: this.model.id,
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true
            },
            {
              key: this.lodash.startCase(this.$t(`purchase_orders.total_biomass`)),
              value:
                this.$numeral(this.model.purchase_order_total_quantity).format("0,0.[00]") + ` ${this.$t("units.kg")}`,
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9 text-end",
              showColon: true
            },
            {
              key: this.lodash.startCase(this.$t(`${this.resourceRoute}.total_debt`)),
              value: this.$numeral(this.model.debt).format("$ 0,0.[00]"),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9 text-end",
              showColon: true
            },
            {
              key: this.lodash.startCase(this.$t(`${this.resourceRoute}.remaining_debt`)),
              value: this.$numeral(this.model.remaining_debt).format("$ 0,0.[00]"),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9 text-end",
              showColon: true
            },
            {
              key: this.lodash.startCase(this.$t(`${this.resourceRoute}.total_accounts_receivable`)),
              value: this.$numeral(this.model.receivable).format("$ 0,0.[00]"),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9 text-end",
              showColon: true
            },
            {
              key: this.lodash.startCase(this.$t(`${this.resourceRoute}.remaining_receivable`)),
              value: this.$numeral(this.model.remaining_receivable).format("$ 0,0.[00]"),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9 text-end",
              showColon: true
            },
            {
              key: this.lodash.startCase(this.$t(`CreatedBy`)),
              value: this.model.creator.name,
              class: "row",
              styles: { fontSize: "10px", opacity: "0.8" },
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true
            },
            {
              key: this.lodash.startCase(this.$t(`${this.resourceRoute}.created_at`)),
              value: this.$moment
                .utc(this.model.created_at)
                .local()
                .format("DD MMMM YYYY HH:mm:ss"),
              class: "row",
              styles: { fontSize: "10px", opacity: "0.8" },
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true
            }
          ];
    },
    relations() {
      return {
        [this.modelVariable || "model"]: [
          {
            name: "purchase_orders",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.purchase_orders`)),
            component: () => import("./purchase_orders/index"),
            props: {},
            listeners: {}
          },
          {
            name: "trips",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.trips`)),
            component: () => import("./trips/index"),
            props: {},
            listeners: {}
          },
          {
            name: "unloads",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.unloads`)),
            component: () => import("./unloads/index"),
            props: {},
            listeners: {},
            _denyShow: this.model.customer_type === "brs"
          },
          {
            name: "sale_notes",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.sale_notes`)),
            component: () => import("./sale_notes/index"),
            props: {},
            listeners: {}
          },
          {
            name: "balancings",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.balancings`)),
            component: () => import("./balancings/index"),
            props: {},
            listeners: {},
            _denyShow: this.model.customer_type === "brs"
          }
        ].filter(i => !i._denyShow)
      };
    }
  },
  methods: {
    handleBack() {
      this.$router.push(this.prevRoute);
    },
    purchaseOrderPartnerName(purchaseOrders) {
      let uniquerCustomers = [...new Set(purchaseOrders.map(purchaseOrder => purchaseOrder.customer?.name))];

      if (uniquerCustomers.length > 1) return `${uniquerCustomers[0]}, ${this.$t("et_al")}`;
      else if (uniquerCustomers.length === 1) return uniquerCustomers[0];
      else return "-";
    },
    partnerNames(purchaseOrderPartner, saleOrder) {
      let processingPartner = saleOrder.buyer_name || saleOrder.trip?.customer?.name || null;
      if (saleOrder.type === "hybrid") processingPartner = saleOrder.buyer_name;
      if (!processingPartner) return purchaseOrderPartner;
      return `${purchaseOrderPartner} ke ${processingPartner}`;
    },
    getModelName() {
      return this.model["id"];
    },
    delete() {
      return this.$axios.delete(`/tickets/${this.$route.params.key}`);
    },
    fetchModel() {
      this.loading = true;
      return this.$axios
        .get(`/tickets/${this.$route.params.key}`, {
          params: {
            with: [
              "creator",
              "purchase_orders.customer",
              "payments.to_bank_account.customer",
              "payments.to_bank_account.bank",
              "payments.paymentables",
              "sale_orders.payments.from_bank_account.customer",
              "sale_orders.payments.from_bank_account.bank"
            ].join(","),
            scope: "leftJoinTicketable"
          }
        })
        .then(response => {
          const {
            data: { data }
          } = response;
          this.model = {
            ...data,
            purchase_order_payments: this.lodash.flatten(data.purchase_orders.map(i => i.payments)),
            sale_order_payments: this.lodash.flatten(data.sale_orders.map(i => i.payments)),
            debt: data.sale_order_balancing_transaction_total_debt + data.purchase_order_total_debt,
            remaining_debt:
              data.sale_order_balancing_transaction_remaining_debt +
              data.sale_order_balancing_transaction_overpaid +
              data.purchase_order_remaining_debt +
              data.purchase_order_overpaid,
            receivable: data.sale_order_total,
            remaining_receivable: data.sale_order_remaining_receivable + data.sale_order_overpaid
          };
          return response;
        })
        .catch(error => this.failedAlert(error))
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div>
      <div class="row position-relative">
        <keep-alive>
          <model-show
            class="col-md-12"
            :loading="loading"
            v-bind="$props"
            :value="model"
            :model-mapped="modelMapped"
            @back-click="handleBack"
            @edit-click="handleEdit"
            @delete-click="handleDelete"
            @print-click="handlePrint"
          >
            <div class="row g-4">
              <div class="col-6 col-md-3">
                <div class="text-neutral-default text-block text-sm text-semibold">
                  {{ lodash.startCase($t(`${resourceRoute}.ticket_id`)) }}
                </div>
                <div class="text-gray-900">{{ model.id }}</div>
              </div>
              <div class="col-6 col-md-3">
                <div class="text-neutral-default text-block text-sm text-semibold">
                  {{ lodash.startCase($t(`purchase_orders.total_biomass`)) }}
                </div>
                <div class="text-gray-900">
                  {{ $numeral(model.purchase_order_total_quantity).format("0,0.[000]") + ` ${$t("units.kg")}` }}
                </div>
              </div>
              <div class="col-6 col-md-3">
                <div class="text-neutral-default text-block text-sm text-semibold">
                  {{ lodash.startCase($t(`${resourceRoute}.purchase_total`)) }}
                </div>
                <div class="text-gray-900">
                  {{ $numeral(model.debt).format("$ 0,0[.]00") }}
                </div>
              </div>
              <div class="col-6 col-md-3">
                <div class="text-neutral-default text-block text-sm text-semibold">
                  {{ lodash.startCase($t(`${resourceRoute}.remaining_debt`)) }}
                </div>
                <div class="text-gray-900">
                  {{ $numeral(model.remaining_debt).format("$ 0,0[.]00") }}
                </div>
              </div>
              <div class="col-6 col-md-3">
                <div class="text-neutral-default text-block text-sm text-semibold">
                  {{ lodash.startCase($t(`${resourceRoute}.sale_total`)) }}
                </div>
                <div class="text-gray-900">
                  {{ $numeral(model.receivable).format("$ 0,0[.]00") }}
                </div>
              </div>
              <div class="col-6 col-md-3">
                <div class="text-neutral-default text-block text-sm text-semibold">
                  {{ lodash.startCase($t(`${resourceRoute}.remaining_receivable`)) }}
                </div>
                <div class="text-gray-900">
                  {{ $numeral(model.remaining_receivable).format("$ 0,0[.]00") }}
                </div>
              </div>
              <div class="col-6 col-md-3">
                <div class="text-neutral-default text-block text-sm text-semibold">
                  {{ lodash.startCase($t(`CreatedBy`)) }}
                </div>
                <div class="text-gray-900">{{ model.creator.name }}</div>
              </div>
              <div class="col-6 col-md-3">
                <div class="text-neutral-default text-block text-sm text-semibold">
                  {{ lodash.startCase($t(`${resourceRoute}.created_at`)) }}
                </div>
                <div class="text-gray-900">
                  {{
                    $moment
                      .utc(model.created_at)
                      .local()
                      .format("DD MMMM YYYY HH:mm:ss")
                  }}
                </div>
              </div>
            </div>
          </model-show>
        </keep-alive>
        <div v-if="!!relations[modelVariable].length" class="col-12 ">
          <template v-for="(relation, index) in relations[modelVariable]">
            <component
              :key="index"
              v-if="relation.component"
              :is="relation.component"
              v-bind="relation.props"
              v-on="relation.listeners"
            ></component>
          </template>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped lang="scss">
.children {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;

  @media (max-width: 768px) {
    position: relative;
  }
}

::v-deep {
  th,
  td {
    vertical-align: middle;
  }
  .card-title {
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 800;
    line-height: 20px;
    letter-spacing: 0.32px;
    color: #6c7589;
  }
}
</style>
